// material-ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface NoMenuPermissionsPageProps {
  handleBackButton: () => void;
  pageError: boolean;
}

// ==============================|| NO ACCESS PERMISSIONS FOR PAGE ERROR PAGE ||============================== //

const NoAccessPermissionsForPage = ({
  handleBackButton,
  pageError
}: NoMenuPermissionsPageProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const DialogLabel = (): string => {
    return pageError
      ? t('common.messages.noPagePermissionsForPageLabel')
      : t('common.messages.noAccessPermissionsForPageLabel');
  };

  const DialogText = (): string => {
    return pageError
      ? t('common.messages.noPagePermissionsForPageText')
      : t('common.messages.noAccessPermissionsForPageText');
  };

  return (
    <Dialog
      open={true}
      aria-labelledby='change-delivery-point-assigment-dialog-title'
      maxWidth='xs'
      fullWidth
    >
      <>
        <DialogTitle id='dialog-title'>{DialogLabel()}</DialogTitle>
        <Divider
          sx={{
            opacity: 1,
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.dark.light + 15
                : theme.palette.grey[200]
          }}
        />
        <DialogContent>
          <Stack spacing={2}>{DialogText()}</Stack>
        </DialogContent>

        <DialogActions sx={{ pr: 2.5 }}>
          <Button size='small' onClick={handleBackButton}>
            {t(`common.button.back`)}
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default NoAccessPermissionsForPage;
